import {UserRightsVO, RightsApi} from '../api';
import {CACHE_KEY_USER_LAYER_OPRAVNENI} from '../queryKeys';
import {LayerId} from '@mc/react-mapio';
import {useQuery} from 'react-query';

export const useOpravneniQuery = (layerIds: LayerId[], serverPublic: boolean, isIframe: boolean) => {
    const sortedLayerIds = layerIds?.filter(n => n).sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
    return useQuery<UserRightsVO[]>(
        [CACHE_KEY_USER_LAYER_OPRAVNENI, JSON.stringify(sortedLayerIds)],
        async () => (await RightsApi.getAllLayerRightsForLoggedInUser(layerIds.map(n => Number(n)))).data,
        {
            enabled: !!(!serverPublic && !isIframe && layerIds.length > 0),
        },
    );
};
